import { Group, Button, Text, Stack } from "@mantine/core";
import { useState } from "react";
import { useSelector } from 'react-redux';
import { selectMoreInfoContent } from '../../../redux/selectors/publicSelector';
import DetailsModal from "../details/details.modal";
import foodImage from "/assets/images/feb_images/image_food.jpeg";
import colors from '../../../utils/styles';

const MoreInfoPage = () => {
    const [modalMoreInfoData, setModalMoreInfoData] = useState<any>(null);
    
    const moreInfoContent = useSelector(selectMoreInfoContent);

    const moreInfoModalDataList = [
        {
            title: moreInfoContent.faqs.title,
            modalType: 'more-info-faqs',
            description: (
                <Stack gap="md">
                    <Text fw={700} style={{ textAlign: 'center' }}>{moreInfoContent.faqs.header}</Text>

                    {moreInfoContent?.faqs?.data?.map((item, index) => (
                        <Stack key={index} gap="xs">
                            <Text fw={700}>{item.title}</Text>
                            <Text>{item.description}</Text>
                        </Stack>
                    ))}

                    <Text fw={700} style={{ textAlign: 'center' }}>{moreInfoContent.faqs.closing}</Text>
                </Stack>
            )
        },
        {
            title: moreInfoContent.bitesAndDrinks.title,
            modalType: 'more-info-bites-and-drinks',
            image: foodImage,
            description: (
                <Stack gap="md">
                    <Text>{moreInfoContent.bitesAndDrinks.description}</Text>

                    {moreInfoContent.bitesAndDrinks.data.map((item, index) => (
                        <Stack key={index} gap="xs">
                            <Text fw={700}>{item.title}</Text>
                            <Text>{item.description}</Text>
                        </Stack>
                    ))}
                </Stack>
            )
        },
        {
            title: moreInfoContent.getToShow.title,
            modalType: 'more-info-get-to-the-show',
            description: (
                <Stack gap="md">
                    <Text fw={700}>{moreInfoContent.getToShow.header}</Text>

                    {moreInfoContent.getToShow.data.map((item, index) => (
                        <Stack key={index} gap="xs">
                            <Text fw={700}>{item.title}</Text>
                            {item.description && <Text>{item.description}</Text>}
                            {item.options && item.options.map((option, optIndex) => (
                                <Text key={optIndex}>{option}</Text>
                            ))}
                        </Stack>
                    ))}

                    <Text>{moreInfoContent.getToShow.closing}</Text>
                </Stack>
            )
        },
        {
            title: moreInfoContent.privateEvents.title,
            modalType: 'more-info-private-events-and-groups',
            description: (
                <Stack gap="md">
                    <Text>{moreInfoContent.privateEvents.description}</Text>

                    {moreInfoContent.privateEvents.data.map((item, index) => (
                        <Stack key={index} gap="xs">
                            <Text fw={700}>{item.title}</Text>
                            {item.description && <Text>{item.description}</Text>}
                            {item.options && item.options.map((option, optIndex) => (
                                <Text key={optIndex}>{option}</Text>
                            ))}
                        </Stack>
                    ))}
                </Stack>
            )
        }
    ];

    const onModalClose = () => {
        setModalMoreInfoData(null);
    };

    return <>
        <Group justify="center" align="center" gap="xl">
            {moreInfoModalDataList.map((data, index) => (
                <Button
                    key={index}
                    radius="lg"
                    style={{ maxWidth: '150px', width: '150px', height: '150px', border: '1px solid #fed537', backgroundColor: colors.appDarkBlue, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.5)', padding: '0' }}
                    onClick={() => setModalMoreInfoData(data)}
                >
                    <Text style={{ color: colors.appYellow, fontSize: '1.5rem', fontWeight: 'bold', textWrap: 'wrap', fontFamily: "Playfair Display", transform: 'scaleY(1.1)', letterSpacing: '0.05em' }}>{data.title}</Text>
                </Button>
            ))}
        </Group>
        {modalMoreInfoData && <DetailsModal
            opened={!!modalMoreInfoData}
            onClose={onModalClose}
            title={modalMoreInfoData.title}
            description={modalMoreInfoData.description}
            image={modalMoreInfoData.image}
            yOffset="120px"
        />}
    </>
};

export default MoreInfoPage;